import React from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCustomSelectValue = styled(Typography)`
  color: #2f2f2f;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
